export default {
  NO_SPACES: /\s/g,
  NUMBERS_ONLY: /[^0-9]/g,
};
